import {PeriodHierarchyContext} from "../PA.Utils/PeriodHierarchyContext";
import * as AsyncLock from 'async-lock';
import * as _ from 'lodash';
import {WB_PeriodRow} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {IwbPeriodHierarchy} from "../PA.Core/PAdbSchemaRowsIF";
import {ILease} from "../PA.Utils/PA.UtilsIF";
import {PeriodService} from "./PeriodService";


export class PeriodHierarchyService {

    private static dbContext: PAdbContext;
    private static _lease: ILease;

    private static dctPeriodHierarchies: {[wbPeriodHID: number]: IwbPeriodHierarchy} = {};
    private static dctPeriodHierarchyContext: {[periodHWbID: number]: PeriodHierarchyContext} = {};
    private static dctLock: any = new AsyncLock();

    static getNodesAtLevel(periodHWbID: number, periodMWbID: number) : Promise<WB_PeriodRow[]> {
        return new Promise<WB_PeriodRow[]>((resolve, error) => {
            PeriodHierarchyService.getHierarchyContext(periodHWbID)
                .then((context) => {
                    return context.getPeriodsOfType(periodMWbID);
                })
                .then((results) => {
                    resolve(results);
                })
                .catch((err) => {
                    error(err);
                })
        })
    }

    /**
     * For the given period hierarchy, find all the period nodes of the given type whose date ranges overlap with the given date range
     * @param periodHWbId Period Hierarchy WB ID
     * @param periodMWbID Period Type WB ID
     * @param startDt Range start
     * @param endDt Range end
     */
    static getNodesAtLevelByDateRange(periodHWbId: number, periodMWbID: number, startDt: Date, endDt: Date) : Promise<WB_PeriodRow[]> {
        return new Promise<WB_PeriodRow[]>((resolve, error) => {
            PeriodHierarchyService.getHierarchyContext(periodHWbId)
                .then((context) => {
                    return context.getPeriodsOfTypeByDateRange(periodMWbID, startDt, endDt);
                })
                .then((results) => {
                    resolve(results);
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    static getChildren(periodHWbID: number, periodWbID: number, childPeriodMWbID?: number) : Promise<number[]> {
        return new Promise<number[]>((resolve, error) => {
            PeriodHierarchyService.getHierarchyContext(periodHWbID)
                .then((context) => {
                    return context.getChildren(periodWbID, childPeriodMWbID);
                })
                .then((results) => {
                    resolve(results);
                })
                .catch((err) => {
                    error(err);
                });
        })
    }

    /**
     * For the given periodWbId, will return all children of the given type, as defined in the given hierarchy. If child type is not specified, will return immediate child
     */
    static getChildPeriodRows(periodHWbID: number, periodWbID: number, childPeriodMWbID?: number): Promise<WB_PeriodRow[]> {
        return new Promise<WB_PeriodRow[]>((resolve, error) => {
            PeriodHierarchyService.getChildren(periodHWbID, periodWbID, childPeriodMWbID)
                  .then((wbIds) => {
                      return PeriodService.getPeriodsByWBID(wbIds);
                  })
                  .then((periodRows) => {
                      resolve(_.orderBy(periodRows, (a) => a.PeriodStartDt, ["asc"]));
                  })
                  .catch((err) => {
                      error(err);
                  });
        });
    }

    static getParent(periodHWbID: number, periodWbID: number, parentPeriodMWbID?: number) : Promise<number> {
        return new Promise<number>((resolve, error) => {
            PeriodHierarchyService.getHierarchyContext(periodHWbID)
                .then((context) => {
                    return context.getPeriodParent(periodWbID, parentPeriodMWbID);
                })
                .then((results) => {
                    resolve(results);
                })
                .catch((err) => {
                    error(err);
                })
        })
    }

    private static getHierarchyContext(periodHWbID: number) : Promise<PeriodHierarchyContext> {
        return new Promise<PeriodHierarchyContext>((resolve, error) => {
            PeriodHierarchyService.dctLock.acquire('global',
                (done: any) => {
                    let context: PeriodHierarchyContext;

                    if (periodHWbID in PeriodHierarchyService.dctPeriodHierarchyContext) {
                        context = PeriodHierarchyService.dctPeriodHierarchyContext[periodHWbID];
                    } else {
                        context = new PeriodHierarchyContext(periodHWbID);
                        PeriodHierarchyService.dctPeriodHierarchyContext[periodHWbID] = context;
                    }

                    done(null, PeriodHierarchyService.dctPeriodHierarchyContext[periodHWbID]);
                    resolve(context);
                })
        })
    }
}
